import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { FormsService } from '@services/forms';
import { ProgressIndicatorService } from '@services/progress';
import { FormAsyncValidators } from '@tcp13equals2/z5-lib';
import { componentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';

import { UsersService } from '../../../../../../services/users';
import { FormEditorInputType } from '../../../../../../shared/components';
import { IUsersManualPasswordResetDialogData } from './users-manual-password-reset.models';

@Component({
	selector: 'app-users-manual-password-reset',
	templateUrl: './users-manual-password-reset.dialog.html'
})
export class UsersManualPasswordResetDialogComponent extends OnDestroyMixin implements OnInit {
	private i18nConfirmManualPasswordReset = this.i18nService.get('', 'app.prompt.users.manual-password-reset.confirm-message');

	public formEditorInputType = FormEditorInputType;
	public hidePassword = true;
	public formInputs = new FormGroup({
		password: new FormControl(null, [Validators.required], [this.formAsyncValidators.password.bind(this.formAsyncValidators)]),
		password2: new FormControl(null, [Validators.required, this.formsService.confirmPasswordMatcher])
	});

	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		private formsService: FormsService,
		@Inject(MAT_DIALOG_DATA) public dialogData: IUsersManualPasswordResetDialogData,
		private dialogRef: MatDialogRef<UsersManualPasswordResetDialogComponent>,
		private formAsyncValidators: FormAsyncValidators
	) {
		super();
	}

	public ngOnInit(): void {
		const password2 = this.formInputs.get('password2');

		this.formInputs
			.get('password')
			.statusChanges.pipe(takeUntil(componentDestroyed(this)))
			.subscribe((status: string) => {
				if (status === 'VALID') {
					password2.enable();
				} else {
					password2.reset();
					password2.disable();
				}
			});

		password2.disable();
	}

	public onFormSubmit(): void {
		const data: FeedbackData = {
			title: FeedbackTitle.warning,
			message: this.i18nConfirmManualPasswordReset,
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.resetPassword();
				} else {
					this.dialogRef.close();
				}
			}
		};

		this.feedbackService.confirm(data);
	}

	private resetPassword(): void {
		 this.progressIndicatorService.spinner(true);
		 this.usersService
		 	.updateUsersPassword(
		 		this.dialogData.user.email,
		 		this.formInputs.value.password
		 	)
		 	.subscribe(
		 		() => {
		 			this.progressIndicatorService.spinner(false);
		 			this.dialogRef.close();
		 		},
		 		(error: any) => {
		 			this.feedbackService.apiError(error);
		 			this.progressIndicatorService.spinner(false);
		 		}
		 	);
	}
}
